module.exports = __webpack_public_path__ + "static/img/logo17.c115bb7a.png";